class SearchModal extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    if (!this.detailsContainer || !this.summaryToggle) {
      console.warn(
        'SearchModal: Gerekli details veya summary öğesi bulunamadı.',
        this
      );
      return;
    }

    this.initialized = true;

    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.key === 'Escape' || event.code === 'Escape') {
        this.close();
        this.summaryToggle.focus();
      }
    });

    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    const closeButton = this.querySelector('button[type="button"]');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }

    const resetButton = this.querySelector('button[type="reset"]');
    if (resetButton) {
      resetButton.addEventListener('click', this.reset.bind(this));
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  disconnectedCallback() {
    if (
      this.detailsContainer &&
      this.detailsContainer.hasAttribute('open')
    ) {
      this.close();
    }
  }

  onSummaryClick(event) {
    event.preventDefault();

    if (this.detailsContainer.hasAttribute('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains('modal-overlay')
    ) {
      this.close();
    }
  }

  open() {
    setScrollbarWidth();
    setHeaderBottomPosition();

    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);

    this.detailsContainer.setAttribute('open', '');
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('search-modal--open');

    const focusContainer =
      this.detailsContainer.querySelector('[tabindex="-1"]');
    const searchInput =
      this.detailsContainer.querySelector('input:not([type="hidden"])');

    if (focusContainer && searchInput) {
      trapFocus(focusContainer, searchInput);
    } else if (searchInput) {
      searchInput.focus();
    }
  }

  close() {
    if (!this.detailsContainer) return;

    removeTrapFocus();
    this.detailsContainer.removeAttribute('open');

    if (this.onBodyClickEvent) {
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }

    document.body.classList.remove('search-modal--open');
    document.dispatchEvent(new CustomEvent('searchmodal:close'));
  }

  reset(event) {
    event.preventDefault();

    const searchInput = this.querySelector('input[type="search"]');
    if (!searchInput) return;

    searchInput.value = '';
    searchInput.dispatchEvent(new Event('input', { bubbles: true }));
    searchInput.focus();
  }
}

if (!customElements.get('search-modal')) {
  customElements.define('search-modal', SearchModal);
}
